import { datadogLogs } from '@datadog/browser-logs'
import { VideoCallScene } from 'src/features/videoCall/types'

export type AgoraLogContext = {
  roomUid: string
  videoCallUserUid: number | null
  scene: VideoCallScene
  [key: string]: unknown
}

export const logAgoraEvent = (
  level: 'info' | 'warn' | 'error',
  message: string,
  context: AgoraLogContext,
): void => {
  if (!import.meta.env.PROD) return
  datadogLogs.logger[level](message, { ...context, source: 'agora-rtc' })
}
